<template>
  <layout>
    <page-header :header="$t('bookings.create')" />
    <div class="content">
      <b-card>
        <h4>{{ $t('bookings.select_account') }}</h4>
        <v-select
          :value="selected"
          :filterable="false"
          :options="users"
          :placeholder="$t('general.type_to_search')"
          @search="fetchUsersWithDebounce"
          @input="onUserSelect"
        >
          <template slot="option" slot-scope="user">
            {{ user.name }} &lt;{{ user.email }}&gt;
          </template>
          <template slot="selected-option" slot-scope="user">
            {{ user.name }} &lt;{{ user.email }}&gt;
          </template>
        </v-select>
      </b-card>
      <div v-show="!!selected">
        <at-widget-booking
          ref="widget"
          :endpoint="endpoint"
          :stripe-key="stripeKey"
          is-admin
          hide-ride-types="transfer,delivery"
          @ready="widgetReady"
        />
      </div>
    </div>
  </layout>
</template>

<script>
import { mapState } from 'vuex'
import { AdminApi } from 'stylemix-vue-admin'
import debounce from 'lodash/debounce'
import vSelect from 'vue-select'
import HasWidgetMixin from './HasWidgetMixin'

const usersApi = new AdminApi('users')

export default {
  components: {
    vSelect,
  },

  mixins: [HasWidgetMixin],

  data() {
    return {
      selected: null,
      users: [],
    }
  },

  computed: {
    ...mapState('admin-auth', ['token']),
  },

  created() {
    this.fetchUsersWithDebounce = debounce(this.fetchUsers, 300)

    this.whenWidget(() => {
      // force commit state cause it resets on widget loaded
      this.$refs.widget.$store.commit('airports/setHiddenRideTypes', [
        'transfer',
        'delivery',
      ])
      this.$refs.widget.$store.commit('airports/setSelectedTab', 'cityTaxi')
    })
  },

  methods: {
    fetchUsers(query) {
      if (!query) {
        return
      }

      usersApi
        .setParameters({
          context: 'booking',
          query,
        })
        .all()
        .then(({ data: users }) => {
          this.users = users
        })
    },

    onUserSelect(user) {
      this.selected = user
      this.widgetStore.dispatch('setAdminSelectedUser', {
        ...user,
        token: this.token,
      })
    },
  },
}
</script>
